/* globals Forms */

window['email_templates#index'] = function () {
  $('input.email-active-switch').on('change', function () {
    const active = $(this).prop('checked')
    const id = $(this).val()
    $.ajax({
      url: `/email_templates/${id}/switch_activity`,
      type: 'PUT',
      data: { active }
    })
  })
}

window['email_templates#edit'] = function () {
  $(document).on('nested:fieldAdded', function () {
    Forms.initFileInputs()
  })
}

window['email_templates#new'] = function () {
  $(document).on('nested:fieldAdded', function () {
    Forms.initFileInputs()
  })
}
